import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import TyreSizeCalculator from '../components/tools/TyreSizeCalculator';

const TyreSizeCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="tyre-size-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Tyre Size & Speedometer Error Calculator"
        description="Compare an original and a replacement tyre size: see what each sidewall number means, how the diameter and ride height change, and how far off the speedometer and odometer will read."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="tyre-size-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <TyreSizeCalculator />
          <ToolGuideCta guidePath="/tools/tyre-size-calculator/guide" toolName="Tyre Size & Speedometer Error Calculator" />
        </div>
      </section>
    </div>
  );
};

export default TyreSizeCalculatorPage;
